export default __webpack_public_path__ + "static/media/man.70ec81bc.png";